import { useTheme } from '@automata/mui-theme';
import { Typography } from '@automata/ui';
import { Box, LinearProgress, keyframes, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';

type ReplanProgressProps = {
  isPlanning?: boolean;
};

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const AnimatedBox = styled(Box)<{
  fade: boolean;
  duration: number;
}>`
  animation: ${(p) => (p.fade ? fadeIn : fadeOut)} ${(p) => p.duration}ms
    forwards;
`;

const ReplanProgress = ({
  isPlanning = false,
}: ReplanProgressProps): JSX.Element | null => {
  const theme = useTheme();

  const fadeDurationMS = 250;

  const [visible, setVisible] = useState(false);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (isPlanning) {
      setVisible(true);
      setFade(true);
    } else if (visible) {
      setFade(false);
      const timer = setTimeout(() => {
        setVisible(false);
      }, fadeDurationMS);
      return () => clearTimeout(timer);
    }
  }, [isPlanning, fadeDurationMS, visible]);

  if (!visible) return null;

  return (
    <AnimatedBox
      fade={fade}
      duration={fadeDurationMS}
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="end"
      gap={1}
    >
      <Typography variant="body1" color={theme.palette.primary[600]}>
        Replanning in progress
      </Typography>
      <LinearProgress sx={{ width: '100%', height: '4px' }} />
    </AnimatedBox>
  );
};

export default ReplanProgress;
